import { UPDATE_CURRENT_LANGUAGE } from '../constants/actionTypes'

export default (state = localStorage.getItem('i18nextLng') || 'en', action) => {
    switch (action.type) {
        case UPDATE_CURRENT_LANGUAGE:
            return action.payload
        default:
            return state
    }
}
